var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalDeal>0)?_c('span',{staticClass:"ml-8 font-weight-medium"},[_vm._v("Total Deal : "+_vm._s(_vm.currency)+" "+_vm._s(_vm.totalDeal))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }